import React from "react";

import Form from 'react-bootstrap/Form';

export type TextAttributeParams = {
  name: string,
  label: string;
  value: string | number;
  disabled?: boolean;
  onChangeCallback: (currentValue: string) => void;
}

/**
 * 
 * @param param0 
 * @returns 
 */
export const EditTextAttribute = ( {name, label, value, onChangeCallback, disabled = false}: TextAttributeParams  ) => {

    const onHandleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      e.preventDefault();
      onChangeCallback(e.target.value);

    }
  
    return (
        <Form.Floating className="mb-1">
            <Form.Control
            key={name}
            id={name}
            type="text"
            placeholder=""
            value={value}
            onChange={onHandleChange}
            disabled = {disabled} 
            />
            <label htmlFor={name}>{label}</label>
  
      </Form.Floating>
    )
  }
